/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilters_viewer = {
    readonly isMatchedSetsEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterMetal_viewer" | "SbSharedRefineMenuFilterStone_viewer" | "SbSharedRefineMenuFilterOrigin_viewer" | "SbSharedRefineMenuFilterCreator_viewer" | "SbSharedRefineMenuFilterMaterial_viewer" | "SbRespRefineMenuFilterDeliveryOptions_viewer" | "SbMobileRefineMenuFilterDeliveryOptions_viewer">;
    readonly " $refType": "SbSharedRefineMenuFilters_viewer";
};
export type SbSharedRefineMenuFilters_viewer$data = SbSharedRefineMenuFilters_viewer;
export type SbSharedRefineMenuFilters_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilters_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMatchedSetsEnabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enableMatchedSetsFacet"
        }
      ],
      "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDeliveryOptions_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '2dc57cf96f2e7742f8da74be8158735a';
export default node;
